// extracted by mini-css-extract-plugin
export default {"policyStatus":"styles_policyStatus__FTXbR"};